module.exports = __webpack_public_path__ + "static/media/apave.9340853d.png";